import React, { useEffect, useState, useCallback } from 'react';
import { CSSTransition } from 'react-transition-group';

import { Translator } from 'ggApp/modules/translator';

import { ANIMATION_DURATION_IN_MS, Wrap, Text, SuggestionList, Suggestion } from './styles';

const SearchSuggestions = ({ className, subCategoryNames = [], isMobileUser = false }) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const updateRandomPlaceholder = useCallback(
        () => setActiveIndex(Math.floor(Math.random() * subCategoryNames.length)),
        [subCategoryNames],
    );

    useEffect(() => {
        updateRandomPlaceholder();
        const categoryNameInterval = setInterval(() => updateRandomPlaceholder(), 5000);

        return () => clearInterval(categoryNameInterval);
    }, [updateRandomPlaceholder]);

    return (
        <Wrap className={className}>
            {!isMobileUser && (
                <Text>
                    <Translator tk="SEARCHBAR_PLACEHOLDER_TEXT_STATIC" />
                </Text>
            )}
            <SuggestionList>
                {subCategoryNames.map((subcategory, index) => (
                    <CSSTransition
                        key={subCategoryNames[index]}
                        timeout={ANIMATION_DURATION_IN_MS}
                        classNames="categoryText"
                        in={index === activeIndex}
                        out={index !== activeIndex}
                    >
                        <Suggestion>
                            {isMobileUser ? (
                                subCategoryNames[index]
                            ) : (
                                <Translator
                                    tk="SEARCHBAR_PLACEHOLDER_TEXT_CATEGORY"
                                    withValues={{
                                        categoryName: subCategoryNames[index],
                                    }}
                                />
                            )}
                        </Suggestion>
                    </CSSTransition>
                ))}
            </SuggestionList>
        </Wrap>
    );
};

export default SearchSuggestions;
